import { AccountState } from './types';
import { APIProgress } from '@shopee-user/api-constants';

export const REDUCER_NAME = 'account';

export const initialState: AccountState = {
  account: null,
  oneCredentialLinked: false,
  oneCredentialWhitelisted: false,
  accountProgress: APIProgress.Init,
  accountError: null,
  loginStatus: null,
  loginStatusError: null,
  loginStatusProgress: APIProgress.Init,
};
